// src/app/App.js
import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ReactGA4 from 'react-ga4';

import TabName from './autotab-name';

// Imports estáticos y Lazy
import KairosMain from './KairosMain';
const SwedaviaMain = React.lazy(() => import('../apps/swedavia/SwedaviaMain'));
const ContrailMain = React.lazy(() => import('../apps/contrail/ContrailMain'));
// 1. Inicialización Global (Correcto)
ReactGA4.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

// 2. Tracker Global (NUEVO AQUÍ)
// Este componente detecta cambios de ruta en TODA la aplicación
function GlobalPageTracker() {
  const location = useLocation();
  useEffect(() => {
    // Enviamos la página vista a GA
    ReactGA4.send({ hitType: 'pageview', page: location.pathname + location.search });
    console.log("GA Pageview:", location.pathname); // Debug (quitar en prod)
  }, [location]);

  return null; // No renderiza nada visual
}

const AppLoader = () => (
  <div style={{ 
    height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: 'sans-serif', color: '#555' 
  }}>
    Loading Module...
  </div>
);

// 3. Smart Redirect Component
// Decide a dónde ir basándose en la sesión activa
const SmartRedirect = () => {
  const swedaviaSession = localStorage.getItem('swedavia_session');
  
  if (swedaviaSession) {
    // Si hay rastro de sesión de Swedavia, intentamos ir allí
    // SwedaviaMain se encargará de validar si el token sigue vivo
    return <Navigate replace to="/swedavia/dashboard" />;
  }

  // Default a Kairos
  return <Navigate replace to="/kairos/weather-map" />;
};

function App() {
  return (
    <BrowserRouter>
      {/* 3. Insertamos el Tracker aquí para que funcione siempre */}
      <GlobalPageTracker />

      <TabName />

      <Suspense fallback={<AppLoader />}>
        <Routes>
          {/* --- RUTAS SWEDAVIA --- */}
          <Route path="/swedavia/*" element={<SwedaviaMain />} />

          {/* --- RUTAS CONTRAIL --- */}
          <Route path="/contrail/*" element={<ContrailMain />} />

          {/* --- RUTAS KAIROS --- */}
          <Route path="/kairos/*" element={<KairosMain />} />

          {/* --- REDIRECCIONES INTELIGENTES --- */}
          <Route path="/" element={<Navigate replace to="/kairos/weather-map" />} />
          <Route path="/index.html" element={<Navigate replace to="/kairos/weather-map" />} />

          {/* Legacy Traps */}
          <Route path="/weather-map" element={<Navigate replace to="/kairos/weather-map" />} />
          <Route path="/performance" element={<Navigate replace to="/kairos/performance" />} />
          <Route path="/analytics" element={<Navigate replace to="/kairos/analytics" />} />
          <Route path="/forecast-metrics" element={<Navigate replace to="/kairos/forecast-metrics" />} />
          <Route path="/email-verified" element={<Navigate replace to="/kairos/email-verified" />} />

          {/* Catch-all */}
          <Route path="*" element={<SmartRedirect />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;